var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._g(_vm._b({ref:"input",staticClass:"gl-form-input",class:_vm.computedClass,domProps:{"value":_vm.localValue}},'input',_vm.computedAttrs,false),_vm.computedListeners))
}
var staticRenderFns = []

export { render, staticRenderFns }